const favoriteBold32 = {
    svg: '<svg style="width:2.00rem; height:2.00rem;" viewBox="0 0 32 32"><polygon points="16 0.5 12 11.9969008 0 11.9969008 9.78 19.6588326 5.936 31.5 16 24.1823347 26.064 31.5 22.22 19.6588326 32 11.9969008 20 11.9969008"/></svg>',
};

export { favoriteBold32 as default };
